import { RouteItem } from '@eastcoal/router/types/route'

import { RANK_ACTION_UUID, RANK_PAGE_UUID } from './constants/uuid'

export const rankRoute: RouteItem = {
  title: '首页排名',
  path: '/rank/list',
  uuid: RANK_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理排名',
      uuid: RANK_ACTION_UUID
    }
  ]
}
